"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WELCOME_PROGRAM_CATEGORY = exports.VOUCHERS = exports.SHIPPING_OFFER = exports.PENDING_EC_ORDERS = exports.ADVICE_HINT_TYPE = void 0;
const ADVICE_HINT_TYPE = exports.ADVICE_HINT_TYPE = 'Advice';
const WELCOME_PROGRAM_CATEGORY = exports.WELCOME_PROGRAM_CATEGORY = 'WelcomeProgram';
const PENDING_EC_ORDERS = exports.PENDING_EC_ORDERS = 'EndConsumerPendingOrders';
const SHIPPING_OFFER = exports.SHIPPING_OFFER = 'ShippingOffer';
const VOUCHERS = exports.VOUCHERS = 'Vouchers';
